<template>
  <div>
    <div class="selectHead">
      <span>个人中心</span>
    </div>
    <section class="personMsg">
      <div class="photo fl">
        <img :src="avatar" alt="用户头像" class="head_icon">

        <label class="alter" for="xFile">修改头像</label>
        <form>
          <input type="file" id="xFile" style="position:absolute;clip:rect(0 0 0 0);" @change="preview($event)" accept="image/png, image/jpeg, image/gif, image/jpg">
        </form>
      </div>
      <div id="preview" class="clear"></div>
      <div>
        <basicMsg :userInformation="userInformation" :birthday="userInformation.birthday" :userId="userId"></basicMsg>
      </div>
    </section>
    <div class="revisePhone">
      <p>
        <img src="./../assets/img/phone.png" alt="" class="phone">
        <span class="leftSpan">绑定手机号：</span>
        <span class="rightSpan" style="color: #333333;">{{mobile}}</span>
        <span class="bule_alert" @click="altMobile">{{buttontext}}</span>
      </p>
    </div>
    <div>
      <alertMobile :layerMB="layerMB" :oldMobile="mobile" @sureMobile="sureMobile"></alertMobile>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { mapActions, mapGetters } from "vuex";
import fetch from "./../fetch";
import basicMsg from "./../components/personMsg/basicMsg.vue";
import teachMsg from "./../components/personMsg/teachMsg.vue";
import alertMobile from "./../components/alertMsg/alertMobile.vue";
import { clientId, brandId } from "./../../config";
export default {
  data() {
    return {
      userId: "",
      userInformation: {},
      avatar: "",
      mobile: "",
      imgUrl: "",
      layerMB: false,
      buttontext: "更换手机号"
    };
  },
  components: {
    basicMsg,
    teachMsg,
    alertMobile
  },
  created() {
    this.$nextTick(() => {
      this.setCrumb("个人资料修改");
      this.mobile = this.getUser().mobile;
      this.userId = this.$route.params.userId;
      this.userInfo();

      // 判断用户是否绑定手机号
      if (this.mobile) {
        this.mobile = this.getUser().mobile;
      } else {
        this.mobile = "未绑定";
        this.buttontext = "绑定";
      }
      console.log(this.mobile)
    });
  },
  watch: {},
  methods: {
    ...mapActions(["removeCrumb", "setCrumb", "setUser"]),
    ...mapGetters(["getUser"]),
    userInfo() {
      fetch.getDetailedInf({ uin: this.userId }).then(res => {
        if (!res) {
          return false;
        }
        this.userInformation = res.data;

        console.log(this.userInformation, "66");
        this.userInformation.mobile = this.getUser().mobile;
        this.userInformation.avatar = this.userInformation.avatar || "static/img/photo.png";
        this.userInformation.password = this.getUser().password;
        this.avatar = this.userInformation.avatar;
        //   console.log("this.avatar", this.avatar)
      });
    },

    sureMobile(res) {
      this.mobile = this.getUser().mobile;
    },

    altMobile() {
      this.layerMB = !this.layerMB;
    },

    preview(e) {
      //   debugger
      var url = e.currentTarget.value;
      var prevDiv = document.getElementById("preview");
      var file = e.target.files || e.dataTransfer.files;
      if (file[0].size >= 5242880) {
        return false;
      }
      if (file[0]) {
        var _this = this;
        var reader = new FileReader();
        reader.onload = function(evt) {
          let src = evt.target.result;

          var image = new Image();
          image.onload = function() {
            //             var canvas = document.createElement('canvas');
            //             var imageWidth = 100;
            //             var imageHeight = 100;
            //             var offsetX = 100;
            //             var offsetY = 100;
            //
            //             canvas.width = imageWidth;
            //             canvas.height = imageHeight;
            //
            //             var context = canvas.getContext('2d');
            //
            //             context.drawImage(image, offsetX, offsetY, imageWidth, imageHeight);
            // var data=;
            _this.save(src);
          };
          image.setAttribute("src", src);
          prevDiv.appendChild(image);
        };
        reader.readAsDataURL(file[0]);
      }
    },
    save(imgsrc) {
      //   console.log("imgsrc",imgsrc)
      let headers = {
        crossDomain: true,
        xhrFields: { withCredentials: true }
      };
      fetch.upload({ file: imgsrc }).then(res => {
        if (!res) {
          console.log("!res", res);
          this.avatar = "static/img/photo.png";
          return false;
        }
        let imgUrl = res.data;
        console.log(res);

        fetch.getAvatar({ avatar: imgUrl }).then(res => {
          if (!res) {
            this.avatar = "static/img/photo.png";
            return false;
          }
          this.avatar = imgUrl;
          this.$toast("修改成功！", "right");

          let userInfo = this.getUser();
          userInfo.avatar = this.avatar;
          this.setUser(userInfo);
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// personMsg.vue?3704a102